import config from "../constants/config";
import {
  getTotal,
  uniqueSolutions,
  isValidEq,
  hasAchieved,
  findSolutions,
  getGridBiggestDiff,
  VALID_HASH_CHARS,
  shuffle,
} from "../utils/gameHelpers";

const generateTile = (cols, rows, exclude) => {
  // let n = Math.ceil((1 - (1 - ((Math.random() ** 10))))
  //  * (config.tileMax - config.tileLow)) + config.tileLow; // more likely to be small
  let n =
    Math.max(
      1,
      Math.ceil(
        Math.random() * (config.tileMax / (Math.random() > 0.8 ? 4 : 2))
      )
    ) + Math.ceil(Math.random() > 0.9 ? config.tileMax / 2 : 0);

  if (cols * rows < config.tileMax) {
    if (exclude.indexOf(n) >= 0) n = generateTile(cols, rows, exclude); // get another
  }
  return n;
};

const newGame = (cols, rows) => {
  const target =
    Math.ceil(Math.random() * (config.targetMax - config.targetMin)) +
    config.targetMin;
  const grid = [];

  for (let i = 0; i < rows * cols; i += 1) {
    grid.push(generateTile(cols, rows, grid));
  }
  const solutions = findSolutions(grid, target);
  if (solutions.length > 0 && (solutions[0].length + 1) / 2 <= 3) {
    const g = { target, grid };
    if (getGridBiggestDiff(g.grid) < VALID_HASH_CHARS.length) return g; // make sure it's convertable
  }
  return newGame(cols, rows);
};

const game = (state = config.initialState.game, action) => {
  switch (action.type) {
    case "SET_GRID_SIZE":
      if (action.cols && action.rows) {
        return {
          ...state,
          cols: action.cols,
          rows: action.rows,
        };
      } else if (action.size) {
        const dimensions = action.size.split("x").map((n) => parseInt(n, 10));

        return {
          ...state,
          cols: dimensions[0],
          rows: dimensions[1],
        };
      }
      return state;
    case "NEW_GAME":
      // let biggestDiff = 0;
      // for (let i = 0; i < 1000; i++) {
      //   const g = newGame(state.cols, state.rows).grid.sort((a, b) => a - b);
      //   const diffs = g.map((a, ai) =>
      //     ai < g.length - 1 ? g[ai + 1] - a : false
      //   );
      //   let bigDiff = Math.max(...diffs);
      //   // console.log("grid", g, diffs, bigDiff);
      //   if (bigDiff > biggestDiff) biggestDiff = bigDiff;
      // }
      // console.log("biggestDiff", biggestDiff);
      const g = newGame(state.cols, state.rows);
      // console.log(
      //   "NEW GAME",
      //   g,
      //   convertGameToHash(g),
      //   convertHashToGame(convertGameToHash(g))
      // );
      return {
        ...state,
        ...g,
        eq: [],
        eqPos: 0,
        solutions: [],
        titleScreen: false,
      };
    case "LOAD_GAME":
      // console.log("LOAD GAME", action.target);
      return {
        ...state,
        target: action.target,
        grid: shuffle(action.grid),
        solutions: [],
        eq: [],
        eqPos: 0,
        rows: Math.floor(Math.sqrt(action.grid.length)),
        cols: Math.floor(
          action.grid.length / Math.floor(Math.sqrt(action.grid.length))
        ),
      };
    case "LOAD_SOLUTIONS":
      return {
        ...state,
        solutions: uniqueSolutions(
          action.solutions.filter(
            (eq) => getTotal(eq) === state.target && isValidEq(eq, state.grid)
          )
        ),
      };
    case "ADD_SOLUTION":
      if (
        getTotal(action.solution) === state.target &&
        isValidEq(action.solution, state.grid)
      ) {
        return {
          ...state,
          solutions: uniqueSolutions([...state.solutions, action.solution]),
        };
      }
      return state;
    case "CLICK_TILE": {
      // console.log("CLICK_TILE1", action);
      let { eqPos } = state;

      // console.log("CLICK_TILE2", eqPos);
      // Look for an preceding operator
      if (eqPos > 0 && config.operators.indexOf(state.eq[eqPos - 1]) < 0)
        eqPos -= 1;
      const eq = [...state.eq.slice(0, eqPos), action.number];
      // console.log(
      //   "CLICK_TILE3",
      //   eqPos,
      //   eq,
      //   state.eq,
      //   state.grid,
      //   state.eq.indexOf(action.number),
      //   state.grid.indexOf(action.number),
      //   isValidEq(eq, state.grid)
      // );
      // CLICK_TILE3 4 (5) [98, '-', 41, '×', 40] 8 4 true
      // CLICK_TILE3 0 [34] [] (9) [9, 22, 28, 34, 40, 41, 47, 70, 98] -1 3 true

      if (
        state.eq.slice(0, eqPos).indexOf(action.number) >= 0 || // number already used
        state.grid.indexOf(action.number) < 0 || // number isn't in the grid
        !isValidEq(eq, state.grid) // new equation isn't valid
      )
        return state;

      let solutions = [...(state.solutions || [])];
      const solutionCount = solutions.length;
      if (getTotal(eq) === state.target) {
        solutions.push(eq);
        solutions = uniqueSolutions(solutions);
      }
      /*
      const achievementDiff = config.achievements.filter(a =>
        hasAchieved(a, solutions, state.target, state.grid)).length -
        config.achievements.filter(a =>
          hasAchieved(a, state.solutions || [], state.target, state.grid)).length;
          */

      const newAchievements = config.achievements.filter((a) =>
        hasAchieved(a, solutions, state.target, state.grid)
      );
      const oldAchievements = config.achievements.filter((a) =>
        hasAchieved(a, state.solutions || [], state.target, state.grid)
      );

      const achievementDiff = newAchievements.filter(
        (e) => !oldAchievements.some((a) => e.name === a.name)
      );

      // console.log("CLICK_TILE4", eq);
      return {
        ...state,
        eq,
        eqPos: eqPos + 1,
        solutions,
        achievementDiff,
        solutionNew: solutionCount !== solutions.length,
      };
    }
    case "CLICK_OPERATOR": {
      // console.log("CLICK_OPERATOR1", action);
      let { eqPos } = state;
      // const eq = [...state.eq.slice(0, eqPos), action.op];
      // console.log(
      //   "CLICK_OPERATOR2",
      //   // eq,
      //   eqPos,
      //   state.eqPos,
      //   state.eq.filter(Number).length,
      //   state.grid.length,
      //   config.operators.indexOf(action.op)
      // );
      if (
        state.eqPos === 0 || // first item can't be an operator
        state.eq.slice(0, eqPos).filter(Number).length === state.grid.length || // all tiles have been used up
        config.operators.indexOf(action.op) < 0 // must be a valid operator
      ) {
        return state;
      }
      if (config.operators.indexOf(state.eq[eqPos - 1]) >= 0) eqPos -= 1;

      // console.log(
      //   "CLICK_OPERATOR3",
      //   config.operators.indexOf(state.eq[eqPos - 1])
      // );
      return {
        ...state,
        eq: [...state.eq.slice(0, eqPos), action.op],
        eqPos: eqPos + 1,
      };
    }
    case "UNDO":
      return {
        ...state,
        eqPos: Math.max(
          state.eqPos -
            (["+", "-", "x", "/"].indexOf(state.eq[state.eqPos - 1]) >= 0
              ? 1
              : 2),
          0
        ),
      };
    case "REDO":
      return {
        ...state,
        eqPos: Math.min(state.eqPos + 2, state.eq.length),
      };
    case "RESET":
      return {
        ...state,
        eq: [],
        eqPos: 0,
      };
    case "CHANGE_TAB":
      return {
        ...state,
        achievementDiff: action.tabIndex === 1 ? [] : state.achievementDiff,
      };
    default:
      return state;
  }
};

/*
const tile = (state, action) => {
  switch (action.type) {
    case 'NEW_GAME':
      return state;
    case 'CLICK_TILE':
      return state;

    default:
      return state;
  }
};
const operator = (state, action) => {
  switch (action.type) {
    case 'CLICK_OPERATOR':
      return state;

    default:
      return state;
  }
};
*/

/*
{
      target: 0,
      grid: [],
      eq: [],
      eqPos: 0,
      solutions: [],
      showHowTo: false,
      showMobileAchievements: false,
      showMobileSolutions: false,
      message: false,
      highlightAchievements: false,
      gridWidth: 297,
      gridHeight: 297,
    };
    */

export default game;
